import { Role } from 'src/app/features/requets/shared/model/Role.model';

export class RoleInformation {
  roles: Role[];
  currentRol: Role;
  tipoValidation: number;
}

